module.exports = __webpack_public_path__ + "static/media/AboutLogo.8413c75a.svg";